import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import Graphql from '../../../../core/services/graphql';

import {
  Container,
  Logo,
  MessageContainer,
  Title,
  DescriptionContainer,
  Button,
} from './styles';

const EndStream = () => {
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);

  const query = Graphql;
  const scope = query.getScope();

  const handleButtonClick = () => {
    setRedirectToDashboard(true);
  };

  if (redirectToDashboard) {
    return <Redirect to="/" />;
  }

  return (
    <Container>
      <MessageContainer>
        <Logo src="/images/playbook-logo.png" alt="Playbook" />

        <DescriptionContainer>
          <Title>This live stream has ended.</Title>
          <Button
            onClick={handleButtonClick}
          >
            {(scope === 'livestream') ? 'Go to Login' : 'Go to Dashboard' }
          </Button>
        </DescriptionContainer>
      </MessageContainer>
    </Container>
  );
};

export default EndStream;
